// extracted by mini-css-extract-plugin
module.exports = {"pintxo-badge":"Badge_pintxo-badge__4bAWU","pintxo-badge-wrapper__badge__value":"Badge_pintxo-badge-wrapper__badge__value__nW3gL"};